// SOUND MANAGER:
module.exports = function (UTILS, config) {
  // INIT:
  var tmpSound;
  this.sounds = [];
  this.listener = {};
  this.rate = 1;

  // TOGGLE:
  this.setVolume = function (volume) {
    Howler.volume(volume);
  };

  // GET SOUND:
  this.getSound = function (id, group) {
    var tmpIndx = id + (group || "") + (window.activeHacker ? "hckd" : "");
    tmpSound = this.sounds[tmpIndx];
    if (!tmpSound) {
      tmpSound = new Howl({
        src: ".././sound/" + (window.activeHacker ? "fart_0" : id) + ".mp3"
      });
      this.sounds[tmpIndx] = tmpSound;
    }
  };

  // PLAY SOUND:
  this.play = function (id, vol, loop, rate) {
    this.getSound(id);
    if (this.rate && (!loop || !tmpSound.isPlaying)) {
      tmpSound.isPlaying = true;
      var tmpID = tmpSound.play();
      tmpSound.volume(vol || 1, tmpID);
      tmpSound.loop(loop, tmpID);
      tmpSound.rate((rate || 1) * this.rate, tmpID);
    }
  };

  // STOP SOUND:
  this.stop = function (id) {
    this.getSound(id);
    if (tmpSound) {
      tmpSound.isPlaying = false;
      tmpSound.stop();
    }
  };

  // PLAY 3D NOT SPACIAL:
  this.play3Dv = function (id, x, y, z, rng, vol, rate, list) {
    var tmpDst = UTILS.getDistance3D(x, y, z, list.x, list.y, list.z);
    var tmpMlt = 1 - tmpDst / rng;
    if (tmpMlt > 0.1) {
      this.getSound(id, "3dv");
      var tmpID = tmpSound.play();
      vol = (vol || 1) * tmpMlt * config.otherSoundMlt;
      tmpSound.volume(vol, tmpID);
      tmpSound.rate(rate || 1, tmpID);
    }
  };

  // PLAY 3D:
  this.play3D = function (id, x, y, z, vol, rate, dist, roll) {
    this.getSound(id, "3d");
    var tmpID = tmpSound.play();
    vol = (vol || 1) * config.otherSoundMlt;
    if (vol > 0.05) {
      tmpSound.volume(vol, tmpID);
      tmpSound.rate(rate || 1, tmpID);
      tmpSound.pos(x, y, z, tmpID);
      tmpSound.pannerAttr({
        refDistance: dist || 25,
        rolloffFactor: roll || 1
      }, tmpID);
    }
  };
};